import { ReactNode } from 'react';
import {
  Check,
  PauseCircle,
  Prohibit,
  Warning,
  Icon,
} from '@phosphor-icons/react';
import { TaskStatusFilter } from 'src/types';
import { InProgressIcon } from 'src/components/InProgressIcon';
import { ConversationsControlMenu } from '../ConversationsControlMenu';
import { ConversationsControlPanel } from '../ConversationsControlPanel';
import { ControlMenuItem } from '../ControlMenuItem';
import { ControlPanelItem } from '../ControlPanelItem';
import { useConversationActions, useConversationsFiltering } from 'src/hooks';

const SVG_SIZE = 20;

export interface FilterControlItem {
  controlItem: TaskStatusFilter;
  Icon?: Icon;
  Component?: ReactNode;
  withDivider?: boolean;
  isTitle?: boolean;
}

interface ConversationControlProps {
  type: 'panel' | 'menu';
}

export const ConversationControl = ({ type }: ConversationControlProps) => {
  const filterControls: FilterControlItem[] = [
    {
      controlItem: TaskStatusFilter.ALL,
      withDivider: true,
      isTitle: true,
    },
    {
      controlItem: TaskStatusFilter.BLOCKED,
      Icon: PauseCircle,
    },
    {
      controlItem: TaskStatusFilter.DONE,
      Icon: Check,
    },
    {
      controlItem: TaskStatusFilter.IN_PROGRESS,
      Component: <InProgressIcon size={SVG_SIZE} />,
    },
    {
      controlItem: TaskStatusFilter.FAILED,
      Icon: Warning,
    },
    {
      controlItem: TaskStatusFilter.STOPPED,
      Icon: Prohibit,
      withDivider: true,
    },
    {
      controlItem: TaskStatusFilter.ALL_AND_ARCHIVED,
    },
  ];

  const { setTaskStatusFilter } = useConversationActions();
  const { taskStatusFilter } = useConversationsFiltering();

  const handleFilterClick = async (filter: TaskStatusFilter) => {
    if (filter === TaskStatusFilter.ALL) {
      setTaskStatusFilter();
    } else {
      setTaskStatusFilter(filter);
    }
  };

  if (type === 'menu') {
    return (
      <ConversationsControlMenu>
        {filterControls.map((item) => (
          <ControlMenuItem
            {...item}
            key={item.controlItem}
            svgSize={SVG_SIZE}
            activeFilter={taskStatusFilter || TaskStatusFilter.ALL}
            onClick={handleFilterClick}
          />
        ))}
      </ConversationsControlMenu>
    );
  }

  return (
    <ConversationsControlPanel>
      {filterControls.map((item) => (
        <ControlPanelItem
          key={item.controlItem}
          {...item}
          activeFilter={taskStatusFilter || TaskStatusFilter.ALL}
          svgSize={SVG_SIZE}
          onClick={handleFilterClick}
        />
      ))}
    </ConversationsControlPanel>
  );
};
